import React from 'react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

interface NbItemsFieldProps {
  value?: number;
  onChange?: (value: number) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
}

const NbItemsField: React.FC<NbItemsFieldProps> = ({
  value = 0,
  onChange,
  placeholder = 'Enter number of items',
  label = 'Number of Items',
  disabled = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numValue = parseInt(e.target.value, 10) || 0;
    onChange?.(numValue);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="nbItems">{label}</Label>
      <Input
        id="nbItems"
        type="number"
        min="0"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default NbItemsField;
